import {useEffect, useState} from "react";

export function useReservationFullscreen() {
    const [isFullscreen, setIsFullscreen] = useState(false);

    useEffect(() => {
        if (!isFullscreen) return;

        const exitOnEscape = (event: KeyboardEvent) => {
            if (event.key === "Escape") setIsFullscreen(false);
        };

        document.addEventListener("keydown", exitOnEscape);
        return () => document.removeEventListener("keydown", exitOnEscape);
    }, [isFullscreen]);

    return {isFullscreen, setIsFullscreen};
}
